<template>
<v-navigation-drawer :clipped="clipped" :value="drawer" @change="toggleDrawer" enable-resize-watcher app class="lighten-2">
  <h3 :class="Settings.documentAvallible() ? 'logo-document' : 'logo'">{{ Settings.appName() }}</h3>
  <v-divider></v-divider>
  <v-list dense class="pt-0">
    <div v-for="route in routes" :key="route.meta.title" v-if="route.navigation && canDisplayNav(route) && isAllowed(route)">
      <v-list-tile v-if="route.children==undefined" :to="{ name: route.name }">
        <v-list-tile-action>
          <v-icon>{{ route.meta.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ $t(route.meta.title) }}</v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>

      <v-list-group v-else-if="route.navigation & route.children!=undefined" :prepend-icon="route.meta.icon " no-action dense class="pt-0">

        <v-list-tile dense class="pt-0" slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{{ route.meta.main_title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-if="route.sub_navigation" :to="{ name: route.name }">
          <v-list-tile-content>
            <v-list-tile-title>{{ $t(route.meta.title) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-for="subRoute in route.children" :key="subRoute.meta.title" :to="{name : subRoute.name}">
          <v-list-tile-content>
            <v-list-tile-title>{{ $t(subRoute.meta.title) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list-group>
    </div>


    <v-list-tile v-if="isAuthenticated" @click="logout()">
      <v-list-tile-action>
        <v-icon>exit_to_app</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t("navigation.logout") }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>



</v-navigation-drawer>
</template>

<script>
import Acl from '@/plugins/Acl'
import navRoutes from '@/router/routes'
import Settings from "@/plugins/Settings";
export default {
  name: "Navigation",
  components: {},
  props: ["drawer", "clipped"],
  data() {
    return {
      Settings,
      routesData: navRoutes,
      accessControl: new Acl()
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    routes() {
      return this.routesData
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function () {
        this.$forceUpdate()
      },
      deep: true
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("authLogout").then(() => {
        this.$store.commit("setSnack", {
          "message": this.$t("login.logout"),
          "color": "info"
        })
        this.$router.push({
          name: 'login'
        })
      })
    },
    toggleDrawer() {
      this.$emit("toggle")
    },
    isAllowed(route) {
      if (route.permission == undefined) return true
      return this.accessControl.isAllowed(route.permission)
    },
    canDisplayNav(route) {
      if (this.isAuthenticated && route.name != "login")
        return true
      else if (!this.isAuthenticated && route.name == 'login')
        return true

      return false;
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Alfa+Slab+One&display=swap&subset=latin-ext');
@font-face {
  src: url('~@/assets/fonts/Comfortaa-Bold.ttf');
  font-family: "Comfortaa";
}

.logo {
  font-family: 'Alfa Slab One';
  width: 100%;
  text-align: center;
  font-size: 60px;
  text-decoration: none !important;
  font-weight: 100;
  color: #424242;
}

.logo-document {
  font-family: 'Comfortaa';
  width: 100%;
  text-align: center;
  font-size: 40px;
  text-decoration: none !important;
  font-weight: 100;
  color: #424242;
}

.theme--dark .logo {
  color: #EEEEEE;
}

.theme--light.v-navigation-drawer,
.theme--light.v-toolbar {
  background-color: #f5f3f2;
}
</style>
